import React from 'react';
import ReactDOM from 'react-dom';
import routes from './routes'
import './index.sass';
import * as serviceWorker from './serviceWorker';
import 'antd/dist/antd.css';

import {FirebaseContext} from './components/Firebase';

ReactDOM.render
(<FirebaseContext.Provider>
        <div>{routes}</div>
    </FirebaseContext.Provider>,
    document.getElementById('root'));




// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
